export const actions = {
  OPEN_SIDE_MODAL: 'OPEN_SIDE_MODAL',
  CLOSE_SIDE_MODAL: 'CLOSE_SIDE_MODAL',
};

export function openSideModal(name) {
  return dispatch =>
    dispatch({
      type: actions.OPEN_SIDE_MODAL,
      payload: {
        name,
      },
    });
}

export function closeSideModal() {
  return dispatch =>
    dispatch({
      type: actions.CLOSE_SIDE_MODAL,
    });
}
